import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'RiskAssessmentOption',
    column_type: 'id',
  },
  created_at: {
    model_name: 'RiskAssessmentOption',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'RiskAssessmentOption',
    column_type: 'datetime',
  },
  content: {
    model_name: 'RiskAssessmentOption',
    column_type: 'string',
  },
  score: {
    model_name: 'RiskAssessmentOption',
    column_type: 'integer',
  },
  position: {
    model_name: 'RiskAssessmentOption',
    column_type: 'integer',
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
